export const iconFontAwesomeNumbers7 = (
	<i className="fa-solid fa-7"></i>
);
